import React from 'react';
import './css/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="modern-footer">
      <div className="footer-container">
        <div className="footer-content">
          <span className="footer-copyright">
            © {currentYear} MyUnivers v3.0.0
          </span>
          <span className="footer-separator">•</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
